export default {"src":"/_next/static/media/banzai_logo_rgb_banzai-blue.62bb8688.svg","height":96,"width":402,"blurWidth":0,"blurHeight":0};